import Marquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

const items = [
  "Sparkling Spaces",
  "Healthier Living",
  "Premium Care",
  "Fully Insured",
  "Eco-Friendly Products",
  "Vetted Professionals",
];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-slate-200 bg-slate-50 py-5">
    <Marquee speed={32} gradient={false} pauseOnHover>
      {items.map((t) => (
        <span
          key={t}
          className="mx-10 flex items-center gap-10 font-serif text-xl italic tracking-wider text-slate-800"
        >
          {t}
          <Sparkles className="h-4 w-4 text-teal-600" />
        </span>
      ))}
    </Marquee>
  </div>
);
